import { createContext, useContext } from 'react';
import { useGetValue } from '@alfa-bank/site-form-utils/hooks/use-get-value';

export interface IContext {
    /** Номер текущего списка */
    currentRow: number;
}

export const Context = createContext<IContext>({
    currentRow: 0,
});

export const useIteratorContext = () => useContext(Context);

interface IIterator {
    /** Название контекста */
    context?: string;
}

interface IUseIterator extends IIterator {
    /** Имя поля */
    name: string;
}
export const useIterator = <T>({ context, name }: IUseIterator): T => {
    const getValue = useGetValue();
    const { currentRow } = useIteratorContext();

    const isContextUnavailable = currentRow === undefined || context === undefined;

    const path = isContextUnavailable ? name : `${context}[${currentRow}]${name}`;

    return getValue<T>(path) as T;
};

interface IUseIteratorObject<T> extends IIterator {
    /** Объект с именами полей */
    names: Record<keyof T, string>;
}
export const useIteratorObject = <T>({ context, names }: IUseIteratorObject<T>): T => {
    const getValue = useGetValue();
    const { currentRow } = useIteratorContext();

    const isContextUnavailable = currentRow === undefined || context === undefined;

    const getPath = (name: unknown = '') =>
        isContextUnavailable ? `${name}` : `${context}[${currentRow}]${name}`;

    return Object.entries(names).reduce((acc, [key, name]) => {
        const path = getPath(name);

        return {
            [key]: getValue(path) as T,
            ...acc,
        };
    }, {} as T);
};
